(function () {
  'use strict';

  // Fire-and-forget: send a clean JSON payload to the merchant's
  // Zapier/Make webhook (if configured) so it can log to Google
  // Sheets/Excel and email a personal inbox. Never blocks or breaks
  // the main Shopify contact submission if it fails or is slow.
  function sendToWebhook(section, formData) {
    var webhookUrl = section && section.getAttribute('data-webhook-url');
    if (!webhookUrl) return;

    var payload = {
      name: formData.get('contact[Name]') || '',
      phone: formData.get('contact[phone]') || '',
      email: formData.get('contact[email]') || '',
      submitted_at: new Date().toISOString(),
      page_url: window.location.href,
      page_title: document.title
    };
    var body = JSON.stringify(payload);

    // iOS Safari can silently drop un-awaited fetch() calls fired
    // from inside an event handler (this is why it worked fine on
    // Android/desktop but not iOS). sendBeacon is built exactly for
    // this "fire once, guarantee delivery" case and is the most
    // reliable option where it's available.
    if (navigator.sendBeacon) {
      var blob = new Blob([body], { type: 'text/plain;charset=utf-8' });
      var queued = navigator.sendBeacon(webhookUrl, blob);
      if (queued) return;
    }

    // Fallback: fetch with keepalive so the browser is told to
    // finish the request even if the calling function has already
    // returned.
    fetch(webhookUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: body,
      keepalive: true
    }).catch(function (err) {
      console.warn('Waitlist webhook failed:', err);
    });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-waitlist-section] form');
    if (!form) return;

    event.preventDefault();

    var section = form.closest('[data-waitlist-section]');
    var formData = new FormData(form);

    sendToWebhook(section, formData);

    var submitBtn = form.querySelector('.waitlist__submit');
    var originalLabel = submitBtn ? submitBtn.textContent : '';
    if (submitBtn) {
      submitBtn.setAttribute('disabled', 'disabled');
      submitBtn.textContent = 'Submitting…';
    }

    fetch(form.action, {
      method: 'POST',
      body: formData,
      headers: { Accept: 'text/html' }
    })
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newForm = doc.querySelector('[data-waitlist-section] form') || doc.querySelector('form.waitlist__form');
        var success = doc.querySelector('[data-waitlist-success]');

        if (success) {
          form.innerHTML = success.outerHTML;
          var successEl = form.querySelector('[data-waitlist-success]');
          if (successEl) successEl.focus();
        } else if (newForm) {
          form.innerHTML = newForm.innerHTML;
        } else {
          form.submit();
        }
      })
      .catch(function () {
        // Network or parsing issue: fall back to a normal form submission.
        form.submit();
      })
      .finally(function () {
        if (submitBtn && document.body.contains(submitBtn)) {
          submitBtn.removeAttribute('disabled');
          submitBtn.textContent = originalLabel;
        }
      });
  });
})();